import { render } from "./AustriaMap.vue?vue&type=template&id=ea652b4a&scoped=true"
const script = {}

import "./AustriaMap.vue?vue&type=style&index=0&id=ea652b4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea652b4a"

export default script